import './index.scss'

const AnimatedLetters = ({ letterClass, strArray, indx }) => {
    return (
        <span>
            {
            strArray.map((char, i) => (
                <span key={char + i} className={`${letterClass} _${i + indx}`}>
                    {char}
                </span>
            ))
        }
        </span>
    )
};

export default AnimatedLetters